<template>
    <div>
        <aiff-modal/>
        <div class="search">
            <div class="search-left">
                <div class="search-img">
                    <img src="/web/images/search-01.svg" alt="search">
                </div>
                <div class="search-left-field-wrap">
                    <input  class="search-left-field" type="text" v-model="search" placeholder="Search"/>
                </div>
            </div>
            <div class="search-right">
                <div class="search-right-btn">
                    <input id="music-upload" name="file" class="files" type="file" multiple accept="audio"
                           @change="handleFilesUpload($event)">
                    <a href="#" id="music-upload-link" class="search-right-btn-add">Add</a>

                    <a  class="search-right-btn-refresh" v-on:click="updatePodcasts">Refresh</a>
                </div>
            </div>
        </div>
        <b-progress v-if="percentCompleted > 0 && percentCompleted < 100"
                    :value="percentCompleted"
                    :max="max"
                    height="3px"
                    variant="danger"
                    class="qwerty"></b-progress>

        <b-alert show dismissible fade
                 @dismissed="dismissCountDown=0"
                 @dismiss-count-down="countDownChanged"
                 variant="success"
                 v-if="typeMessage === 'success'">
            <span>{{ resultMessage }}</span>
        </b-alert>
        <b-alert show dismissible fade variant="danger" v-if="typeMessage === 'error'">
            <span>{{ resultMessage }}</span>
        </b-alert>
        <div class="admin-content">
            <div class="songs-block" v-if="lastTracks.length > 0">
                <div class="songs-block-name">
                    <p>Последние добавленные</p>
                </div>

                <span v-for="(track, key) in lastTracksFilteredList" :class="{editing: track === editedTrack}" v-cloak>

                     <b-progress v-if="player.id === track.id"
                                 :value="audioCurrentTimePercent"
                                 :max="max"
                                 height="0.260vw"
                                 variant="danger"
                                 @click.native="changeCurrentTimePercent(track.id, $event)"
                                 :id="'player-progress-' + track.id"
                                 class="progress-player"
                     ></b-progress>

                    <div class="songs-bar">

                        <div class="album-image">
                             <input type="file" :id="'img-upload-'+ track.id" class="img-upload" accept="image/*"
                                    v-on:change="handleImageUpload"/>
                             <img class="songs-bar-album edit"
                                  v-bind:src="imagePreview ? imagePreview : track.image ? track.image.src : '/storage/images/covers/default.png'"
                                  v-on:click="openFileUploader(track.id)"/>

                             <img class="songs-bar-album view"
                                  v-bind:src="track.image ? track.image.src : '/storage/images/covers/default.png'">
                        </div>

                        <div class="play-icon">
                            <svg-icon class="icon-width" icon="play_admin-01" @click.native="play(track.id)"
                                      v-if="player.id !== track.id"/>
                            <svg-icon class="icon-width" icon="pausa_admin-01" @click.native="pause(track.id)"
                                      v-if="player.id === track.id"/>

                            <audio :id="'player-' + track.id" :src="'/app/music/tmp/' + track.name"></audio>
                        </div>

                        <div class="songs-bar-album-name">
                            <p class="view">{{ track.artist }}</p>
                            <input class="edit" type="text" v-model="track.artist"/>
                        </div>


                        <div class="songs-bar-info-song">
                            <p class="songs-bar-info-song-name view">{{ track.title }}</p>
                             <input class="edit" type="text" v-model="track.title"/>
                            <p class="songs-bar-info-song-time view">{{ track.duration }}</p>
                        </div>

                        <a class="songs-bar-aiff view" @click="show(track)">AIFF</a>
                        <a class="songs-bar-button view" @click="editTrack(track)">Редактировать</a>

                        <a class="songs-bar-button edit" @click="saveTrack(track)">Сохранить</a>
                        <a class="songs-bar-button edit" @click="closeEdit">Отменить</a>

                        <div class="songs-bar-delete">
                            <svg-icon class="x-del-width" icon="x_admin-01"
                                      @click.native="deleteTrack(track.id, key, true)"/>
                        </div>

                    </div>
                </span>
            </div>

            <div class="songs-block">
                <div class="songs-block-name">
                    <p>Все треки</p>
                </div>

                <Container @drop="!search ? onDrop(allTracksFilteredList, $event) : ''">

                    <Draggable v-for="(track, key) in allTracksFilteredList" :key="track.id" :class="{editing: track === editedTrack}" >

                    <b-progress v-if="player.id === track.id"
                                :value="audioCurrentTimePercent"
                                :max="max"
                                height="0.260vw"
                                variant="danger"
                                @click.native="changeCurrentTimePercent(track.id, $event)"
                                :id="'player-progress-' + track.id"
                                class="progress-player"
                    ></b-progress>


                     <div class="draggable-item songs-bar">

                         <div class="album-image">
                             <input type="file" :id="'img-upload-'+ track.id" class="img-upload" accept="image/*"
                                    v-on:change="handleImageUpload"/>
                             <img class="songs-bar-album edit"
                                  v-bind:src="imagePreview ? imagePreview : track.image ? track.image.src : '/storage/images/covers/default.png'"
                                  v-on:click="openFileUploader(track.id)"/>

                             <img class="songs-bar-album view"
                                  v-bind:src="track.image ? track.image.src : '/storage/images/covers/default.png'">

                         </div>

                          <div class="play-icon">
                            <svg-icon class="icon-width" icon="play_admin-01" @click.native="play(track.id)"
                                      v-if="player.id !== track.id"/>
                            <svg-icon class="icon-width" icon="pausa_admin-01" @click.native="pause(track.id)"
                                      v-if="player.id === track.id"/>

                            <audio :id="'player-' + track.id" :src="'/storage/podcasts/channels/' + track.channel_id + '/'  + track.name"></audio>
                        </div>


                        <div class="songs-bar-album-name">
                            <p class="view">{{ track.artist }}</p>
                            <input class="edit" type="text" v-model="track.artist"/>
                        </div>


                        <div class="songs-bar-info-song">
                            <p class="songs-bar-info-song-name view">{{ track.title }}</p>
                             <input class="edit" type="text" v-model="track.title"/>
                            <p class="songs-bar-info-song-time view">{{ track.duration }}</p>
                        </div>

                        <a class="songs-bar-aiff view" @click="show(track)">AIFF</a>
                        <a class="songs-bar-button view" @click="editTrack(track)">Редактировать</a>
                        <a class="songs-bar-button edit" @click="saveTrack(track)">Сохранить</a>
                        <a class="songs-bar-button edit" @click="closeEdit">Отменить</a>

                        <div class="songs-bar-delete">
                            <svg-icon class="x-del-width" icon="x_admin-01" @click.native="deleteTrack(track.id, key)"/>
                        </div>

                    </div>

                    </Draggable>
                </Container>
            </div>

        </div>
    </div>
</template>

<script>

  import SvgIcon from '../../components/layout/SvgIcon'
  import AiffModal from '../../components/modals/AiffModal'
  import bAlert from 'bootstrap-vue/es/components/alert/alert'
  import bProgress from 'bootstrap-vue/es/components/progress/progress'
  import { Container, Draggable } from "vue-smooth-dnd"

  export default {
    components: {
      SvgIcon,
      bAlert,
      bProgress,
      AiffModal,
      Container,
      Draggable
    },

    data () {
      return {
        files: '',
        lastTracks: [],
        allTracks: [],
        editedTrack: null,
        currentChannelId: null,

        file: '',
        imagePreview: '',

        player: {
          id: null
        },

        search: '',

        typeMessage: '',
        resultMessage: '',
        dismissSecs: 5,
        dismissCountDown: 0,

        percentCompleted: 0,
        max: 100,

        audioCurrentTimePercent: 0,
        download_link: ''
      }
    },

    methods: {

      onDrop: function(source, dropResult) {
        let removedIndex = dropResult["removedIndex"];
        let addedIndex = dropResult["addedIndex"];
        if (removedIndex !== null && addedIndex !== null) {
          let itemToAdd = source.splice(removedIndex, 1)[0];
          source.splice(addedIndex, 0, itemToAdd);
          this.allTracks = source
        }
      },

      play (id) {
        this.audioCurrentTimePercent = 0
        this.stopAllTracks()

        let audio = document.getElementById('player-' + id)
        audio.play()
        this.player.id = id

        let self = this
        audio.onended = function () {
          self.player.id = false
        }

        audio.addEventListener("timeupdate", function() {
          let currentTime = audio.currentTime;
          let duration = audio.duration;

          self.audioCurrentTimePercent = currentTime/duration*100
        });
      },

      pause (id) {
        let audio = document.getElementById('player-' + id)
        audio.pause()
        this.player.id = null
      },

      changeCurrentTimePercent (id, event) {
        let audio = document.getElementById('player-' + id)
        let click_c = event.layerX;
        let width_c = document.getElementById('player-progress-' + id).offsetWidth;
        let perc_pr = Math.floor(click_c / (width_c / 100));
        let track_l = Math.floor(audio.duration);
        let track_cur = Math.floor((track_l / 100) * perc_pr);
        this.audioCurrentTimePercent = perc_pr
        audio.currentTime = track_cur;
      },

      stopAllTracks () {
        let sounds = document.getElementsByTagName('audio')
        for (let i = 0; i < sounds.length; i++)
          sounds[i].pause()
      },

      handleFilesUpload (event) {
        for (let i = 0; i < event.currentTarget.files.length; i++) {
          let data = new FormData()
          data.append('file', event.currentTarget.files[i])
          data.append('channel_id', this.currentChannelId)
          data.append('is_podcast', '1')

          let _this = this;

          this.$http.post('/api/tracks/', data, {
            onUploadProgress: function(progressEvent) {
              _this.percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
            }

          })
            .then(response => {
              this.lastTracks.unshift(response.data)
            })
            .catch(error => {

            });
        }
      },

      getAllTracks () {
        this.$http.get('/api/tracks/podcasts-for-channel/' + this.currentChannelId)
          .then(response => {
            this.lastTracks = response.data.last
            this.allTracks = response.data.all
          })
      },

      deleteTrack (trackId, index, last) {
        if (confirm("Do you really want to delete it?")) {
          this.$http.delete('/api/tracks/' + trackId)
            .then(response => {
              this.typeMessage = response.data.type
              this.resultMessage = response.data.message
            })

          this.$delete(last ? this.lastTracks : this.allTracks, index)
        }
      },

      editTrack (track) {
        this.editedTrack = track
      },

      closeEdit () {
        this.editedTrack = null
      },

      saveTrack (track) {
        let formData = new FormData()

        formData.append('artist', track.artist)
        formData.append('title', track.title)
        formData.append('image', this.file)

        this.$http.post('/api/tracks/' + track.id, formData)
          .then(response => {
            this.typeMessage = response.data.type
            this.resultMessage = response.data.message
            this.dismissCountDown = this.dismissSecs
          })

        this.editedTrack = null
      },

      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      setCurrentChannel () {
        this.currentChannelId = this.$store.state.channel_id
      },

      openFileUploader (id) {
        document.getElementById('img-upload-' + id).click()
      },

      handleImageUpload (e) {
        this.file = e.target.files[0]
        let reader = new FileReader()

        reader.addEventListener('load', function () {
          this.imagePreview = reader.result
        }.bind(this))

        if (this.file) {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            reader.readAsDataURL(this.file)
          }
        }
      },

      updatePodcasts () {
        this.$http.post('/api/tracks/position/update', {
          podcasts: this.allTracks,
        })


        this.$http.post('/api/stream/update/podcasts', {
          channel_id: this.currentChannelId,
        })

        location.reload()
      },

      filterByArtistAndTitle (tracks) {
        return tracks.filter(track => {
          return (
            track.artist.toLowerCase().includes(this.search.toLowerCase()) ||
            track.title.toLowerCase().includes(this.search.toLowerCase())
          )
        })
      },

      show (track) {
        this.$modal.show('save-aiff-link',{track: track})
      },

    },

    mounted () {
      document.getElementById('music-upload-link').addEventListener('click', function (e) {
        e.preventDefault()
        document.getElementById('music-upload').click()
      })

      this.setCurrentChannel()
      this.getAllTracks()
    },

    computed: {
      allTracksFilteredList() {
        if(this.search){
          return this.filterByArtistAndTitle(this.allTracks)
        }
        return this.allTracks
      },

      lastTracksFilteredList() {
        return this.filterByArtistAndTitle(this.lastTracks)
      },
    },


    created() {

      this.$store.subscribe((mutation, state) => {
        if(mutation.type = 'updateChannel'){
          this.setCurrentChannel()
          this.getAllTracks()
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
    #music-upload {
        display: none
    }

    .img-upload {
        display: none
    }

    [v-cloak] {
        display: none;
    }

    .edit {
        display: none;
    }

    .editing .edit {
        display: block;
    }

    .editing .view {
        display: none;
    }

    .progress, .alert{
        margin-bottom: 0;
    }

    .progress-player{
        margin-top: 2px;
        margin-bottom: -2px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/dashboard/Podcasts.vue